import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d19e79d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icons" }
const _hoisted_2 = {
  id: "timer",
  class: "time"
}
const _hoisted_3 = {
  id: "player1-info",
  class: "d-flex align-center flex-inherit"
}
const _hoisted_4 = { class: "player-name" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = {
  key: 0,
  class: "score"
}
const _hoisted_7 = {
  key: 1,
  class: "score"
}
const _hoisted_8 = { class: "status" }
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["player", {
      right: _ctx.isRightAlign,
      'your-turn': _ctx.playTurn != '' && _ctx.playTurn != null && _ctx.playTurn === _ctx.playerId,
      'opponent-turn': _ctx.playTurn == '' || _ctx.playTurn == null || _ctx.playTurn !== _ctx.playerId,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.gameKind !== 'PRACTICE')
        ? (_openBlock(), _createBlock(_component_fa_icon, {
            onClick: _ctx.concedeGame,
            key: "flag",
            icon: "flag",
            color: "gray",
            title: "Concede",
            class: "fa-icon concede"
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_ctx.gameKind === 'SNOOKER' || _ctx.gameKind === 'SNOOKER6')
        ? (_openBlock(), _createBlock(_component_fa_icon, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.passBack(_ctx.enablePassback))),
            key: "hand-paper",
            icon: "hand-paper",
            color: "gray",
            class: _normalizeClass(["fa-icon", {
          'enable-passback': _ctx.enablePassback && _ctx.playTurn != '' && _ctx.playTurn != null && _ctx.playTurn === _ctx.playerId,
        }]),
            title: "Pass back"
          }, null, 8, ["class"]))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.timeLeft), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, [
          (_ctx.align === 'left' && _ctx.displayScore)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, " (" + _toDisplayString(_ctx.score) + ") ", 1))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.name) + " ", 1),
          (_ctx.align === 'right' && _ctx.displayScore)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, " (" + _toDisplayString(_ctx.score) + ") ", 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.playTurn ? (_ctx.playTurn === _ctx.playerId ? "To Play" : "Waiting!") : ""), 1)
      ]),
      _createElementVNode("img", {
        src: _ctx.ball,
        alt: "Ball image",
        class: "ball-image"
      }, null, 8, _hoisted_9)
    ])
  ], 2))
}